/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as AuthenticateRouteImport } from './routes/authenticate'
import { Route as ActivateRouteImport } from './routes/activate'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedFirmwareRouteImport } from './routes/_authenticated/firmware'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedProjectsIndexRouteImport } from './routes/_authenticated/projects/index'
import { Route as AuthenticatedPeopleIndexRouteImport } from './routes/_authenticated/people/index'
import { Route as AuthenticatedDevicesIndexRouteImport } from './routes/_authenticated/devices/index'
import { Route as AuthenticatedAccountIndexRouteImport } from './routes/_authenticated/account/index'
import { Route as ProjectProject_idPublicRouteImport } from './routes/project/$project_id/public'
import { Route as DeviceFguidPublicRouteImport } from './routes/device/$fguid/public'
import { Route as AuthenticatedProjectProject_idRouteImport } from './routes/_authenticated/project/$project_id'
import { Route as AuthenticatedDeviceFguidRouteImport } from './routes/_authenticated/device/$fguid'

const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticateRoute = AuthenticateRouteImport.update({
  id: '/authenticate',
  path: '/authenticate',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivateRoute = ActivateRouteImport.update({
  id: '/activate',
  path: '/activate',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedFirmwareRoute = AuthenticatedFirmwareRouteImport.update({
  id: '/firmware',
  path: '/firmware',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsIndexRoute =
  AuthenticatedProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPeopleIndexRoute =
  AuthenticatedPeopleIndexRouteImport.update({
    id: '/people/',
    path: '/people/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDevicesIndexRoute =
  AuthenticatedDevicesIndexRouteImport.update({
    id: '/devices/',
    path: '/devices/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountIndexRoute =
  AuthenticatedAccountIndexRouteImport.update({
    id: '/account/',
    path: '/account/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const ProjectProject_idPublicRoute = ProjectProject_idPublicRouteImport.update({
  id: '/project/$project_id/public',
  path: '/project/$project_id/public',
  getParentRoute: () => rootRouteImport,
} as any)
const DeviceFguidPublicRoute = DeviceFguidPublicRouteImport.update({
  id: '/device/$fguid/public',
  path: '/device/$fguid/public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedProjectProject_idRoute =
  AuthenticatedProjectProject_idRouteImport.update({
    id: '/project/$project_id',
    path: '/project/$project_id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDeviceFguidRoute =
  AuthenticatedDeviceFguidRouteImport.update({
    id: '/device/$fguid',
    path: '/device/$fguid',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activate': typeof ActivateRoute
  '/authenticate': typeof AuthenticateRoute
  '/error': typeof ErrorRoute
  '/firmware': typeof AuthenticatedFirmwareRoute
  '/device/$fguid': typeof AuthenticatedDeviceFguidRoute
  '/project/$project_id': typeof AuthenticatedProjectProject_idRoute
  '/device/$fguid/public': typeof DeviceFguidPublicRoute
  '/project/$project_id/public': typeof ProjectProject_idPublicRoute
  '/account/': typeof AuthenticatedAccountIndexRoute
  '/devices/': typeof AuthenticatedDevicesIndexRoute
  '/people/': typeof AuthenticatedPeopleIndexRoute
  '/projects/': typeof AuthenticatedProjectsIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activate': typeof ActivateRoute
  '/authenticate': typeof AuthenticateRoute
  '/error': typeof ErrorRoute
  '/firmware': typeof AuthenticatedFirmwareRoute
  '/device/$fguid': typeof AuthenticatedDeviceFguidRoute
  '/project/$project_id': typeof AuthenticatedProjectProject_idRoute
  '/device/$fguid/public': typeof DeviceFguidPublicRoute
  '/project/$project_id/public': typeof ProjectProject_idPublicRoute
  '/account': typeof AuthenticatedAccountIndexRoute
  '/devices': typeof AuthenticatedDevicesIndexRoute
  '/people': typeof AuthenticatedPeopleIndexRoute
  '/projects': typeof AuthenticatedProjectsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/activate': typeof ActivateRoute
  '/authenticate': typeof AuthenticateRoute
  '/error': typeof ErrorRoute
  '/_authenticated/firmware': typeof AuthenticatedFirmwareRoute
  '/_authenticated/device/$fguid': typeof AuthenticatedDeviceFguidRoute
  '/_authenticated/project/$project_id': typeof AuthenticatedProjectProject_idRoute
  '/device/$fguid/public': typeof DeviceFguidPublicRoute
  '/project/$project_id/public': typeof ProjectProject_idPublicRoute
  '/_authenticated/account/': typeof AuthenticatedAccountIndexRoute
  '/_authenticated/devices/': typeof AuthenticatedDevicesIndexRoute
  '/_authenticated/people/': typeof AuthenticatedPeopleIndexRoute
  '/_authenticated/projects/': typeof AuthenticatedProjectsIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activate'
    | '/authenticate'
    | '/error'
    | '/firmware'
    | '/device/$fguid'
    | '/project/$project_id'
    | '/device/$fguid/public'
    | '/project/$project_id/public'
    | '/account/'
    | '/devices/'
    | '/people/'
    | '/projects/'
    | '/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activate'
    | '/authenticate'
    | '/error'
    | '/firmware'
    | '/device/$fguid'
    | '/project/$project_id'
    | '/device/$fguid/public'
    | '/project/$project_id/public'
    | '/account'
    | '/devices'
    | '/people'
    | '/projects'
    | '/settings'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/activate'
    | '/authenticate'
    | '/error'
    | '/_authenticated/firmware'
    | '/_authenticated/device/$fguid'
    | '/_authenticated/project/$project_id'
    | '/device/$fguid/public'
    | '/project/$project_id/public'
    | '/_authenticated/account/'
    | '/_authenticated/devices/'
    | '/_authenticated/people/'
    | '/_authenticated/projects/'
    | '/_authenticated/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ActivateRoute: typeof ActivateRoute
  AuthenticateRoute: typeof AuthenticateRoute
  ErrorRoute: typeof ErrorRoute
  DeviceFguidPublicRoute: typeof DeviceFguidPublicRoute
  ProjectProject_idPublicRoute: typeof ProjectProject_idPublicRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authenticate': {
      id: '/authenticate'
      path: '/authenticate'
      fullPath: '/authenticate'
      preLoaderRoute: typeof AuthenticateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activate': {
      id: '/activate'
      path: '/activate'
      fullPath: '/activate'
      preLoaderRoute: typeof ActivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/firmware': {
      id: '/_authenticated/firmware'
      path: '/firmware'
      fullPath: '/firmware'
      preLoaderRoute: typeof AuthenticatedFirmwareRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/': {
      id: '/_authenticated/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AuthenticatedProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/people/': {
      id: '/_authenticated/people/'
      path: '/people'
      fullPath: '/people/'
      preLoaderRoute: typeof AuthenticatedPeopleIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/devices/': {
      id: '/_authenticated/devices/'
      path: '/devices'
      fullPath: '/devices/'
      preLoaderRoute: typeof AuthenticatedDevicesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/': {
      id: '/_authenticated/account/'
      path: '/account'
      fullPath: '/account/'
      preLoaderRoute: typeof AuthenticatedAccountIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/project/$project_id/public': {
      id: '/project/$project_id/public'
      path: '/project/$project_id/public'
      fullPath: '/project/$project_id/public'
      preLoaderRoute: typeof ProjectProject_idPublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/device/$fguid/public': {
      id: '/device/$fguid/public'
      path: '/device/$fguid/public'
      fullPath: '/device/$fguid/public'
      preLoaderRoute: typeof DeviceFguidPublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/project/$project_id': {
      id: '/_authenticated/project/$project_id'
      path: '/project/$project_id'
      fullPath: '/project/$project_id'
      preLoaderRoute: typeof AuthenticatedProjectProject_idRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/device/$fguid': {
      id: '/_authenticated/device/$fguid'
      path: '/device/$fguid'
      fullPath: '/device/$fguid'
      preLoaderRoute: typeof AuthenticatedDeviceFguidRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedFirmwareRoute: typeof AuthenticatedFirmwareRoute
  AuthenticatedDeviceFguidRoute: typeof AuthenticatedDeviceFguidRoute
  AuthenticatedProjectProject_idRoute: typeof AuthenticatedProjectProject_idRoute
  AuthenticatedAccountIndexRoute: typeof AuthenticatedAccountIndexRoute
  AuthenticatedDevicesIndexRoute: typeof AuthenticatedDevicesIndexRoute
  AuthenticatedPeopleIndexRoute: typeof AuthenticatedPeopleIndexRoute
  AuthenticatedProjectsIndexRoute: typeof AuthenticatedProjectsIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedFirmwareRoute: AuthenticatedFirmwareRoute,
  AuthenticatedDeviceFguidRoute: AuthenticatedDeviceFguidRoute,
  AuthenticatedProjectProject_idRoute: AuthenticatedProjectProject_idRoute,
  AuthenticatedAccountIndexRoute: AuthenticatedAccountIndexRoute,
  AuthenticatedDevicesIndexRoute: AuthenticatedDevicesIndexRoute,
  AuthenticatedPeopleIndexRoute: AuthenticatedPeopleIndexRoute,
  AuthenticatedProjectsIndexRoute: AuthenticatedProjectsIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ActivateRoute: ActivateRoute,
  AuthenticateRoute: AuthenticateRoute,
  ErrorRoute: ErrorRoute,
  DeviceFguidPublicRoute: DeviceFguidPublicRoute,
  ProjectProject_idPublicRoute: ProjectProject_idPublicRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
